<template>
  <b-card no-body>
    <b-card-body>
      <b-form @submit.prevent="load" @keyup.enter="load">
        <b-card bg-variant="light" data-manual-filter :body-class="filtersOpen ? '' : 'lg-filter-collapsed'">
          <button
            type="button"
            class="btn btn-outline-primary lg-filter-toggle w-100 d-flex justify-content-between align-items-center mb-2"
            @click="toggleFilters"
          >
            <span class="d-flex align-items-center">
              <b-icon icon="funnel" font-scale="1.1" class="mr-2"></b-icon>
              <span>Filtros</span>
            </span>
            <b-icon :icon="filtersOpen ? 'chevron-up' : 'chevron-down'" font-scale="1.1"></b-icon>
          </button>

          <div class="lg-filter-container" v-show="filtersOpen">
          <b-form-row>
            <lg-form-const-select label="Situação:" cols="12" sm="4" md="2" @change="load" v-model="form.situacao"
              :options="optionsFilterSituacao" />
            <lg-form-input v-model="form.numero" label="Nº" description=" " cols="12" sm="4" md="5" />
            <lg-form-input v-model="form.descricao" label="Título" description=" " cols="12" sm="4" md="5" />
          </b-form-row>
          <b-form-row>
            <b-col cols="12" class="text-right">
              <b-button id="localizarConcaContabil" class="ml-3 mr-2 my-2" size="sm" style="height: 20px" pill variant="primary" @click="load()">
                <div class="btn-size-alinhamento">
                  <b-icon icon="search" />
                  <b-tooltip target="localizarConcaContabil" title="Localizar" triggers="hover"></b-tooltip>

                </div>
              </b-button>
              <b-button id="novaConta" class="ml-3 mr-2 my-2" @click="abrirModalEdit" size="sm" style="height: 20px" pill
                variant="primary">
                <div class="btn-size-alinhamento">
                  <b-icon  icon="plus" />
                </div>
                <b-tooltip target="novaConta" title="Adicionar novo..." triggers="hover"></b-tooltip>

              </b-button>
            </b-col>
          </b-form-row>
          </div>
        </b-card>
      </b-form>
      <b-card bg-variant="light">
        <b-table responsive class="mt-2" small :busy="this.busy" :items="this.records" :fields="this.tableFields"
          :hover="true" @row-dblclicked="contaContabilSelect" show-empty>
          
          <template #empty>
            <p>Nenhum registro encontrado</p>
          </template>


          
          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </template>

          <template v-slot:cell(editar)="{ item }">
            <b-button :id="'editar-' + item.id" class="my-2 mx-2" size="sm" pill variant="primary"
              @click="abrirModalEdit(item)">
              <b-icon icon="pencil-square" />
              <b-tooltip :target="'editar-' + item.id" title="Editar..." triggers="hover"></b-tooltip>
            </b-button>
          </template>
          <template v-slot:cell(situacao)="{ item }">
            <b-form-checkbox v-model="item.situacao" @change="alteraSituacao(item)" name="check-button" switch size="lg"
              :value="1" :unchecked-value="0" />
          </template>

        </b-table>
        <b-row style="margin-top: 12px" v-if="records && records.length > 0">
          <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
            Página {{ page }} de {{ totalPage }} - {{ total }} registros
          </b-col>
          <b-col cols="6">
            <div class="d-flex justify-content-end align-items-end">
              <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page" :per-page="perPage"
                :total-rows="total" ></b-pagination>
            </div>
          </b-col>
        </b-row>
      </b-card>
      <ContaContabilForm v-if="showModalEdit" @close="cancelar" :isModal="true" :id="id" :prefix="updatedPrefix" />
    </b-card-body>
  </b-card>

</template>

<script>
import ResourceService from "@/core/api/ResourceService"
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import ConfirmMixin from "@/core/mixins/confirm"
import { ListResourceMixin } from "@/core/mixins/resource"
import ContaContabilForm from "./ContaContabilForm.vue"

export default {
  components: {
    LgFormInput,
    LgFormConstSelect,
    ContaContabilForm
  },
  data() {
    return {
      showModalEdit: false,
      filtersOpen: true,
      optionsFilterSituacao: [
        { key: "filterSituacao", text: "Todos", value: undefined },
        { key: "filterSituacao", text: "Ativo", value: 1 },
        { key: "filterSituacao", text: "Inativo", value: 0 },
      ],
      form: {
        descricao: "",
        numero: "",
        situacao: 1,
      },
    }
  },
  props: {
    prefix: {
      Array,
      default: () => [],
    },
  },
  mixins: [ListResourceMixin, ConfirmMixin],
  beforeMount() {
    this.$service = new ResourceService(`/api/conta-contabil`)
  },
  mounted() {
    this.load()
  },
  watch: {
    page() {
      this.load()
    },
  },
  computed: {
    updatedPrefix() {
      return [...this.prefix, "Conta Contábil"]
    },
    title() {
      return this.updatedPrefix.join(" > ")
    },
    tableFields() {
      return [
        { key: "numeroFmt", label: "Número" },
        { key: "descricao", label: "Título" },
        { key: "funcao", label: "Função" },
        { key: "editar", label: "", tdClass: "w-1 align-items-center" },
        { key: "situacao", label: "", tdClass: "w-1 align-items-center" },
      ]
    },
  },
  methods: {
    toggleFilters() {
      this.filtersOpen = !this.filtersOpen
    },
    cancelar() {
      this.showModalEdit = false
      this.id = null
      this.load()
    },
    abrirModalEdit(item) {
      this.id = item.id
      this.showModalEdit = true
    },
    async load() {
      let filtro = {}
      if (this.form.descricao) {
        filtro.descricao = this.form.descricao
      }
      if (this.form.numero) {
        filtro.numero = this.form.numero
      }
      if (this.form.situacao != undefined) {
        filtro.situacao = this.form.situacao
      }

      this.busy = true;
      await this.$loadResource({
        limit: this.perPage,
        page: this.page,
        params: filtro,
      })
    },
    contaContabilSelect(item) {
      this.$emit("onDblClickContaContabil", item)
    },
    async alteraSituacao(item) {
      let response = await this.$confirm(
        "Deseja " +
        (item.situacao === 1 ? "ativar" : "desativar") +
        " a Conta?",
        item.descricao.toUpperCase()
      )
      if (response == true) {
        this.confirmarAlteracaoSituacao(item)
      } else {
        item.situacao = item.situacao === 1 ? 0 : 1
      }
    },

    async confirmarAlteracaoSituacao(item) {
      const { status } = await this.$service.alteraSituacao(item)
      if (status == 200) {
        this.$notify({
          type: "success",
          message: `Registro ${item.situacao ? "Ativado" : "Desativado"
            } com sucesso!`,
        })
      } else {
        this.$notify({
          type: "danger",
          message: `Erro ao ${item.situacao ? "Ativar" : "Desativar"
            } o registro!`,
        })
      }
    },
  },
}
</script>
